/**
 * @namespace client/admin
 *
 * @NOTE: some business write here would actually more  make more sense if
 *        they were put into a dedicated "feature-wise" folder
 *        (eg. "Something/Parameters/Admin"?)
 */
import { concatAll } from '~/utils/lib/core/prelude'

/**
 * @typedef {string} compte_id eg "cpt_etrottaghs_8xxxxxxxxxx_xxxxxxxxxx"
 */

/**
 * @enum {typeof CIVILITE[keyof typeof CIVILITE]}
 * @readonly
 */
export const CIVILITE = /** @type {const} */ ({
  MR: 'MR',
  MME: 'MME'
})

/**
 * @enum {typeof PARAMETERS_SERVICE[keyof typeof PARAMETERS_SERVICE]}
 * @readonly
 */
export const PARAMETERS_SERVICE = /** @type {const} */ ({
  ACHATS: 'achats', // Achats
  UTILISATEURS: 'permission_management', // Gestion des utilisateurs
  CLIENT: 'client', // Fiche client
  DOCUTHEQUE: 'docutheque', // Accès docuthèque
  EMBAUCHES: 'embauche', // Embauches
  CONGES: 'conges', // Congés
  SATD: 'satd', // SATD
})

/** @readonly */
export const LICENCE_CONTACT_FORM_URL = 'https://share-eu1.hsforms.com/19ZsqAqlLSMSIuK3Fm6zgRw2b8v3l'

/** @desc Subroute will be managed by the Controller */
export const getListRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ company_code = '',
  ) => concatAll([
    `/data/${structure_id}`,
    `/parametres`,
    `/utilisateurs/liste`,
  ].concat( appendCompanyQuery(company_code) ))

export const getListActiveRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ company_code = '',
  ) => concatAll([
    `/data/${structure_id}`,
    `/parametres`,
    `/utilisateurs/liste/actifs`,
  ].concat( appendCompanyQuery(company_code) ))

export const getListPendingRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ company_code = '',
  ) => concatAll([
    `/data/${structure_id}`,
    `/parametres`,
    `/utilisateurs/liste/invitations`,
  ].concat( appendCompanyQuery(company_code) ))

export const getListDeletedRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ company_code = '',
  ) => concatAll([
    `/data/${structure_id}`,
    `/parametres`,
    `/utilisateurs/liste/supprimés`,
  ].concat( appendCompanyQuery(company_code) ))

export const getCreationRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ company_code = '',
  ) => concatAll([
    `/data/${structure_id}`,
    `/parametres`,
    `/utilisateurs/invitation`,
  ].concat( appendCompanyQuery(company_code) ))

export const getAchatsRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ company_code = '',
  ) => concatAll([
    `/data/${structure_id}`,
    `/parametres`,
    `/achats`,
  ].concat( appendCompanyQuery(company_code) ))

export const getDetailsRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {string} */ compte_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ company_code = '',
  ) => concatAll([
    `/data/${structure_id}`,
    `/parametres`,
    `/utilisateurs/${compte_id}/details`,
  ].concat( appendCompanyQuery(company_code) ))

/**
 * @param {string} company_code
 * @return {string[]}
 */
function appendCompanyQuery(company_code) {
  if (!company_code)
    return []

  return [ `?company=${encodeURIComponent(company_code)}` ]
}

